module.exports = __webpack_public_path__ + "static/media/wlzs.8f69f65e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/wlzs.png
// module id = 1871
// module chunks = 0 1